module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 28.6833ea86.png";